import React from 'react';
import { Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useAuth } from 'lib/auth';

const messageKey = (companySwitch) => {
  if (companySwitch.linked) {
    return companySwitch.from ? 'website:auth.linkedCompanyUnavailable' : 'website:auth.linkedCompanyUnknown';
  }

  return companySwitch.fromActive ? 'website:auth.companySwitchedFromActive' : 'website:auth.companySwitched';
};

export const CompanySwitchedBanner = () => {
  const { t } = useTranslation();
  const { companySwitch, dismissCompanySwitch } = useAuth();

  if (!companySwitch) {
    return null;
  }

  return (
    <Alert severity="warning" onClose={dismissCompanySwitch} sx={{ mt: 2 }}>
      {t(messageKey(companySwitch), companySwitch)}
    </Alert>
  );
};
